import { BrowserModule } from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { NgModule, APP_INITIALIZER} from '@angular/core';
import {HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {ErrorInterceptor } from './helpers/error.interceptor';
import {JwtInterceptor } from './helpers/jwt.interceptor';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import 'moment/locale/fr';
import * as moment from 'moment';
import { Page404Component } from './components/page404/page404.component';
import {NgxWebstorageModule} from 'ngx-webstorage';
import {AppConfigService} from './services/appconfig.service';
import {TranslationService} from './services/translate.service';
import {FileUploadModule} from 'ng2-file-upload';
@NgModule({
  declarations: [
    AppComponent,
    Page404Component
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgxWebstorageModule.forRoot(),
    HttpClientModule,
       TranslateModule.forRoot({
          loader: {
            provide: TranslateLoader,
            // useFactory: HttpLoaderFactory,
            useClass: TranslationService,
            deps: [HttpClient, AppConfigService]
          }
        }),
    BrowserAnimationsModule,
    FileUploadModule
  ],
  entryComponents: [
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [AppConfigService],
      useFactory: (appConfigService: AppConfigService) => {
        return () => {
          return appConfigService.loadAppConfig();
        };
      }
    }
  ],
  exports: [
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor() {
    moment.locale('fr');
  }
}
